import React from "react";
import CustomCard from "../../../shared/CustomCard";
import { Box } from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import DescriptionIcon from "@mui/icons-material/Description";
import HistoryIcon from "@mui/icons-material/History";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptIcon from "@mui/icons-material/Receipt";

function ClaimReports() {
  const reports = [
    {
      title: "GSS",
      icon: PublicIcon,
      path: "claims/gss-report",
    },
    {
      title: "Claim",
      icon: PublicIcon,
      path: "claims/claim-report",
    },
    {
      title: "Submission Report",
      icon: DescriptionIcon,
      path: "claims/submission",
    },
    {
      title: "Submission History",
      icon: HistoryIcon,
      path: "claims/history",
    },
    {
      title: "Open Batch",
      icon: FolderOpenIcon,
      path: "claims/open-batch",
    },
    {
      title: "TPA Report",
      icon: AccountBalanceIcon,
      path: "claims/tpa",
    },
    {
      title: "IP Credit Statement",
      icon: ReceiptIcon,
      path: "claims/ip-credit",
    },
  ];

  return (
    <Box sx={{ p: 1 }}>
      <Box className=" grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {reports.map((report, index) => (
          <CustomCard
            key={index}
            title={report.title}
            icon={report.icon}
            path={report.path}
            color="#0070C2"
          />
        ))}
      </Box>
    </Box>
  );
}

export default ClaimReports;
